import { Bell, LogOut, Settings, User, Wallet } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@/components/ui/Avatar';
import { Dropdown } from '@/components/ui/Dropdown';
import { useAuthStore } from '@/stores/authStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useWalletStore } from '@/stores/walletStore';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/lib/cn';

export function Header() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const unreadCount = useNotificationStore((s) => s.unreadCount);
  const wallets = useWalletStore((s) => s.wallets);
  const { logout } = useAuth();

  const displayName = user?.profile?.displayName ?? 'User';
  const hasWallet = wallets.length > 0;

  return (
    <header className="sticky top-0 z-30 h-16 bg-dark-900/80 backdrop-blur-xl border-b border-dark-600">
      <div className="flex items-center justify-between h-full px-6">
        <div>
          <h1 className="text-lg font-semibold text-white">
            Welcome back, {displayName}
          </h1>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/wallet')}
            className={cn(
              'flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors',
              hasWallet
                ? 'bg-success-500/10 text-success-400 border border-success-500/30'
                : 'bg-dark-700 text-gray-400 border border-dark-500 hover:text-white'
            )}
          >
            <Wallet className="w-4 h-4" />
            <span>{hasWallet ? 'Connected' : 'No Wallet'}</span>
          </button>

          <button
            onClick={() => navigate('/settings')}
            className="relative p-2 text-gray-400 hover:text-white hover:bg-dark-700 rounded-lg transition-colors"
          >
            <Bell className="w-5 h-5" />
            {unreadCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-error-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          <Dropdown
            trigger={
              <Avatar
                src={user?.profile?.avatar}
                name={displayName}
                size="sm"
              />
            }
            items={[
              {
                key: 'profile',
                label: 'Profile',
                icon: <User className="w-4 h-4" />,
                onClick: () => navigate('/profile/me'),
              },
              {
                key: 'settings',
                label: 'Settings',
                icon: <Settings className="w-4 h-4" />,
                onClick: () => navigate('/settings'),
              },
              {
                key: 'logout',
                label: 'Logout',
                icon: <LogOut className="w-4 h-4" />,
                danger: true,
                onClick: logout,
              },
            ]}
          />
        </div>
      </div>
    </header>
  );
}
